import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
import { useSuccessToast } from "../toast/useSuccessToast";

export const useSubmitKuchikomyuSurveyQuestionRegister = (restaurantId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();

  const onSubmit = async (data:any) => {
    try {
      data['restaurant'] = restaurantId
      await customAuthAxios.post(
        'kuchikomyu/survey-questions/',
        data
      );
      showToast('登録が完了しました')
      navigate(-1);
    } catch (error:any) {
    } finally {
    }
  };

  return onSubmit;
};